import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';

export interface NotificationDto {
  id: string;
  type: string;
  actor: { id: string; name: string } | null;
  thread_id: string | null;
  message_id: string | null;
  subject_type: string;
  subject_id: string;
  preview: string;
  read_at: string | null;
  created_at: string;
}

export interface NotificationsResponse {
  items: NotificationDto[];
  unread_count: number;
}

export function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: async () => {
      const { data } = await apiClient.get<NotificationsResponse>('/notifications', {
        params: { limit: 30 },
      });
      return data;
    },
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
  });
}

export function useMarkRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.post(`/notifications/${id}/read`);
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
  });
}

export function useMarkAllRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await apiClient.post('/notifications/read-all');
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
